import {
  SvgGoFlightVariant,
  SvgCurrencyExchange,
  SvgReceiptLong,
  SvgPerson,
  SvgViewTimeline,
  SvgAccountBalance,
  SvgRequestQuote,
  SvgTicket,
  SvgFolder,
  SvgFolderCopy,
  SvgFilter,
  SvgAccountBalanceWallet,
  SvgExpenses,
  SvgLocalActivity,
} from "~/components/Icon/icons";
import SvgHandshake from "~/components/Icon/icons/Handshake";
import { NavigateFunction } from "react-router-dom";

export interface QuickAction {
  label: string;
  icon: React.ComponentType<any>;
  background?: string;
  color?: string;
  textColor: string;
  action?: () => void;
}

export const createQuickOptionsActions = ({
  navigate,
}: {
  navigate: NavigateFunction;
}): QuickAction[] => [
  {
    label: "Meus cartões",
    icon: SvgAccountBalanceWallet,
    textColor: "$primary-base",
    background: "#F2F8FF",
    color: "#005BC4",
    action: () => navigate("/cartoes/meus-cartoes"),
  },
  {
    label: "Cadastrar funcionário",
    icon: SvgPerson,
    textColor: "$primary-base",
    background: "#F2F8FF",
    color: "#005BC4",
    action: () => navigate("/configuracoes/funcionarios"),
  },
  {
    label: "Dashboard travel",
    icon: SvgViewTimeline,
    textColor: "$primary-base",
    background: "#F2F8FF",
    color: "#005BC4",
    action: () => navigate("/dashboard-bi"),
  },
  {
    label: "Modelos de aprovação",
    icon: SvgReceiptLong,
    textColor: "#005BC4",
    background: "#F2F8FF",
    color: "#005BC4",
    action: () => navigate("/configuracoes/modelos-de-aprovacao"),
  },
  {
    label: "Motivos de viagem",
    icon: SvgCurrencyExchange,
    textColor: "$primary-base",
    background: "#F2F8FF",
    color: "#005BC4",
    action: () => navigate("/configuracoes/motivos-de-viagem"),
  },
];

export const createQuickConfigurationActions = ({
  navigate,
}: {
  navigate: NavigateFunction;
}): QuickAction[] => [
  {
    label: "Parâmetros",
    icon: SvgFilter,
    textColor: "$primary-base",
    background: "#F2F8FF",
    color: "#005BC4",
    action: () => navigate("/configuracoes/parametros/empresas"),
  },
  {
    label: "Dados bancários",
    icon: SvgExpenses,
    textColor: "$primary-base",
    background: "#F2F8FF",
    color: "#005BC4",
    action: () => navigate("/configuracoes/dados-bancarios"),
  },
  {
    label: "Centros de custo",
    icon: SvgAccountBalance,
    textColor: "$primary-base",
    background: "#F2F8FF",
    color: "#005BC4",
    action: () => navigate("/configuracoes/centros-de-custo"),
  },
  {
    label: "Funcionários",
    icon: SvgPerson,
    textColor: "$primary-base",
    background: "#F2F8FF",
    color: "#005BC4",
    action: () => navigate("/configuracoes/funcionarios"),
  },
  {
    label: "Projetos",
    icon: SvgFolderCopy,
    textColor: "$primary-base",
    background: "#F2F8FF",
    color: "#005BC4",
    action: () => navigate("/configuracoes/projetos"),
  },
  {
    label: "Políticas (expenses)",
    icon: SvgRequestQuote,
    textColor: "$primary-base",
    background: "#F2F8FF",
    color: "#005BC4",
    action: () => navigate("/configuracoes/politicas-de-despesas"),
  },
  {
    label: "Motivos de viagem",
    icon: SvgTicket,
    textColor: "$primary-base",
    background: "#F2F8FF",
    color: "#005BC4",
    action: () => navigate("/configuracoes/motivos-de-viagem"),
  },
  {
    label: "Políticas de compra",
    icon: SvgHandshake,
    textColor: "$primary-base",
    background: "#F2F8FF",
    color: "#005BC4",
    action: () => navigate("/configuracoes/politicas-de-compra"),
  },
  {
    label: "Orçamentos",
    icon: SvgCurrencyExchange,
    textColor: "$primary-base",
    background: "#F2F8FF",
    color: "#005BC4",
    action: () => navigate("/configuracoes/orcamentos"),
  },
  {
    label: "Gestão de bilhetes",
    icon: SvgLocalActivity,
    textColor: "$primary-base",
    background: "#F2F8FF",
    color: "#005BC4",
    action: () => navigate("/configuracoes/gestao-de-bilhetes"),
  },
];

export const createQuickAgencyConfigurationActions = ({
  navigate,
}: {
  navigate: NavigateFunction;
}): QuickAction[] => [
  {
    label: "Empresas",
    icon: SvgAccountBalance,
    textColor: "$primary-base",
    background: "#F2F8FF",
    color: "#005BC4",
    action: () => navigate("/configuracoes/empresas"),
  },
  {
    label: "Credenciais",
    icon: SvgPerson,
    textColor: "$primary-base",
    background: "#F2F8FF",
    color: "#005BC4",
    action: () => navigate("/configuracoes/credenciais"),
  },
  {
    label: "Cartões de crédito",
    icon: SvgAccountBalance,
    textColor: "$primary-base",
    background: "#F2F8FF",
    color: "#005BC4",
    action: () => navigate("/configuracoes/cartoes-creditos"),
  },
  {
    label: "Taxas",
    icon: SvgReceiptLong,
    textColor: "$primary-base",
    background: "#F2F8FF",
    color: "#005BC4",
    action: () => navigate("/configuracoes/taxas"),
  },
  {
    label: "Markups",
    icon: SvgFilter,
    textColor: "$primary-base",
    background: "#F2F8FF",
    color: "#005BC4",
    action: () => navigate("/configuracoes/markups"),
  },
  {
    label: "Markdowns",
    icon: SvgFilter,
    textColor: "$primary-base",
    background: "#F2F8FF",
    color: "#005BC4",
    action: () => navigate("/configuracoes/markdowns"),
  },
  {
    label: "Hotéis offline",
    icon: SvgGoFlightVariant,
    textColor: "$primary-base",
    background: "#F2F8FF",
    color: "#005BC4",
    action: () => navigate("/configuracoes/hoteis-offline"),
  },
  {
    label: "Categorias de custo",
    icon: SvgFolder,
    textColor: "$primary-base",
    background: "#F2F8FF",
    color: "#005BC4",
    action: () => navigate("/configuracoes/categorias-de-custo"),
  },
];

export const createQuickAgencyActions = ({ navigate }: { navigate: NavigateFunction }) => [
  {
    label: "Empresas",
    icon: SvgAccountBalance,
    textColor: "$primary-base",
    background: "#F2F8FF",
    color: "#005BC4",
    action: () => navigate("/configuracoes/empresas"),
  },
  {
    label: "Taxas",
    icon: SvgReceiptLong,
    textColor: "$primary-base",
    background: "#F2F8FF",
    color: "#005BC4",
    action: () => navigate("/configuracoes/taxas"),
  },
  {
    label: "Credenciais",
    icon: SvgPerson,
    textColor: "$primary-base",
    background: "#F2F8FF",
    color: "#005BC4",
    action: () => navigate("/configuracoes/credenciais"),
  },
];
